import React, { useState, useEffect } from 'react';
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import '../../App.css'
import '../../style.css';

function App() {
  const [localpokemondata , setLocalPokemonData ] = useState([])

  // コンポーネントがマウントされたときにlocalStorageからデータを取得
  useEffect(() => {
    const storePokemonData = localStorage.getItem("pokemondata");
    console.log("ローカルストレージからデータを取得:", storePokemonData);

    if (storePokemonData) {
      const parsed = JSON.parse(storePokemonData);

      // id で重複排除（※後に出てきたデータを優先して残す）
      const unique = Array.from(
        new Map(
          (Array.isArray(parsed) ? parsed : []).map((p) => [String(p.id), p])
        ).values()
      );

      setLocalPokemonData(unique);
    }
  }, []);

  return (
    <Box sx={{ m : 1 , p : 4 }}>
      <Paper 
        sx={{ m: 1, p: 1 ,
                bgcolor      : '#f5f5dc'  ,
                borderRadius : "1px"      , 
                height       : "250px"    ,
                width        : '250px'    ,
                overflowY    : 'auto'     ,
                position     : 'absolute' , // 絶対位置指定
                top          : '20px'     , // 縦位置を50pxに指定
                left         : '40px'     , // 横位置を20pxに指定
      }}>
        <Grid item xs={12} align="left">
          <Typography
            sx={{
              fontSize: '13px', // フォントサイズ
            }}>つかまえたかず：{localpokemondata.length}ひき / 898 ひき</Typography>
        </Grid>
        {localpokemondata
          .slice() // 元の配列を変更しないようにコピーを作成
          .sort((a, b) => a.id - b.id) // IDを昇順にソート
          .map((pokemon, index) => (
          <Box key={index} >
            <Grid container spacing={0} >
              {/* ポケモンの画像 */}
              <Grid item xs={6} align="center">
                {pokemon.image && (
                <img
                  src     = {pokemon.image}
                  width   = "120px"
                  height  = "120px"
                  alt     = "Pokemon"
                  style={{
                    border: 'none', // 画像の枠線を削除
                  }}/>)}
                {/* No.表示 */}
                <Typography
                  sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "14px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                  }}>No.{pokemon.id}</Typography>
              </Grid>

              <Grid item xs={6} align="left">
                <br></br>
                {/* 名前表示 */}
                <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // Kalamフォント
                    fontSize     : "16px"    , 
                    color        : '#000000' , // フォントの色を黒に設定
                    marginBottom : '10px', // 下にマージンを追加
                    }}>{pokemon.name}</Typography>

                {/* 分類表示 */}
                <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // Kalamフォント
                    fontSize     : "12px"    , 
                    color        : '#000000' , // フォントの色を黒に設定
                    marginBottom : '5px', // 下にマージンを追加
                    }}>{pokemon.genus}</Typography>

                {/* 高さ表示 */}
                <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // Kalamフォント
                    fontSize     : "12px"    , 
                    color        : '#000000' , // フォントの色を黒に設定
                    marginBottom : '5px', // 下にマージンを追加
                    }}>たかさ　{(pokemon.height / 10).toFixed(1)}m</Typography>

                {/* 重さ表示 */}
                <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // Kalamフォント
                    fontSize     : "12px"    , 
                    color        : '#000000' , // フォントの色を黒に設定
                    marginBottom : '5px', // 下にマージンを追加
                    }}>おもさ　{(pokemon.weight / 10).toFixed(1)}kg</Typography>
              </Grid>

              <Grid item xs={12} align="center">
                <Typography
                      sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // Kalamフォント
                      fontSize     : "12px"    , 
                      color        : '#000000' , // フォントの色を黒に設定
                      fontWeight   : 'bold'    , // フォントを太字に設定
                      }}>――□―□―□―□―――□―□―□―□――</Typography>
              </Grid>

              {/* 説明文表示 */}
              <Grid item xs={12} align="left">
                <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // Kalamフォント
                    fontSize     : "14px"    , 
                    color        : '#000000' , // フォントの色を黒に設定
                    }}>{pokemon.text}</Typography>
              </Grid>
              <Grid item xs={12} align="left">
                <Typography
                  sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "12px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                  fontWeight   : 'bold'    , // フォントを太字に設定
                  }}>―――――――――――――――――――――</Typography>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Paper>
    </Box>
  )
}

export default App;
